import styled, { css } from 'styled-components';

import { yourCodeButton } from '@rewardopl/styles/z-index';

import Section from '../../section.styles';

export const Button = styled.button`
  position: fixed;
  bottom: calc(env(safe-area-inset-bottom) + 67px + 12px);
  ${() =>
    navigator.standalone &&
    css`
      bottom: calc(15px + 67px + 12px);
      bottom: calc(max(15px, env(safe-area-inset-bottom)) + 67px + 12px);
    `}
  right: 12px;
  z-index: ${yourCodeButton};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: var(--border-radius-round);
  background-color: var(--yellow);
  box-shadow: var(--shadow-1);
  color: var(--text-on-white);

  @media screen and (min-width: 769px) {
    bottom: var(--gap);
    right: var(--gap);
  }
`;

export const Wrapper = styled(Section)`
  padding-top: var(--gap);
`;

export const ContentWrapper = styled.div`
  flex-grow: 1;
  max-width: 140px;
  margin-left: var(--gap);
`;
